import styled from 'styled-components';
import { Link } from "react-router-dom";


export const StyledLink = styled(Link)`
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  justify-content: space-between;
  background: var(--black-200);
  border-bottom: 1px solid var(--darker-primary);
  padding: 1.5rem;
  color: var(--white);

  .seen {
    background: var(--black-200);
  }

  .unseen {
    background: var(--black-100);
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  p {
    font-size: 0.875rem;
    line-height: 1.5rem;
    text-align: left;
    margin-left: 1rem;
    font-family: "Inter";
    font-style: normal;
    font-weight: 400;
  }
`

export const ImgContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: var(--darker-primary);
  border-radius: 0.25rem;
  padding: 0.5rem;

  img {
    width: 30px;
    height: 30px;
    padding: 0.2rem;
  }
`

export const ImgLeft = styled.img`
  transform: rotate(180deg);
`